import { useQuery } from '@tanstack/react-query';
import { STALE_TIME } from 'infrastructure/consts/stale-time';
import { sortArrayByFieldName } from 'utils/helpers/sort-array-by-field-name';

import useApi from '../use-api';

import type { IAdherenceSettingQueueLimit } from 'infrastructure/interfaces';

const api = `core-2/adherence-settings/queue-limits`;

export const useGetQueueLimits = () => {
  const { loadData } = useApi();

  const {
    data = [],
    error,
    isLoading,
  } = useQuery<IAdherenceSettingQueueLimit[]>({
    queryKey: ['useGetQueueLimits'],
    staleTime: STALE_TIME,
    queryFn: async () => {
      const res = await loadData<IAdherenceSettingQueueLimit[]>(api);
      if (res) return sortArrayByFieldName(res, 'from');
      return [];
    },
  });

  return {
    data,
    isLoading,
    error,
  };
};
